import React, { Component } from 'react';
import MuiButton from '@material-ui/core/Button';

import './Button.css';

class Button extends Component {
  getFullWidth() {
    return this.props.block;
  };

  getFontSize() {
    let fontSize;
    switch (this.props.size) {
      case 'large':
        fontSize = '1.1rem';
        break;
      case 'small':
        fontSize = '.8rem';
        break;
      default:
        fontSize = '1rem';
    }
    return fontSize;
  };

  getMargin() {
    let margin;
    switch (this.props.size) {
      case 'large':
        margin = '4rem';
        break;
      case 'small':
        margin = '0';
        break;
      default:
        margin = '1rem';
    }
    return margin;
  };

  getPadding() {
    let padding;
    switch (this.props.size) {
      case 'large':
        padding = '1.3rem 3rem';
        break;
      case 'small':
        padding = '.7rem 2rem';
        break;
      default:
        padding = '1rem 2rem';
    }
    return padding;
  };

  render() {
    return (
      <MuiButton classes={this.props.classes}
        type={this.props.type}
        fullWidth={this.getFullWidth()}
        size={this.props.size}
        style={{
          fontSize: this.getFontSize(),
          margin: this.getMargin(),
          padding: this.getPadding()
        }}>
        {this.props.children}
      </MuiButton>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js